export default __webpack_public_path__ + "static/media/dtt-landing-large.ec04c0dc.jpg";